import api from './api';

export const getTenants = (params) => api.get('/v1/tenants', { params });
export const getTenant = (id) => api.get(`/v1/tenants/${id}`);
export const createTenant = (data) => api.post('/v1/tenants', data);
export const updateTenant = (id, data) => api.put(`/v1/tenants/${id}`, data);
export const deleteTenant = (id) => api.delete(`/v1/tenants/${id}`);

export const getTenantAdmins = (id) => api.get(`/v1/tenants/${id}/admins`);
export const createTenantAdmin = (id, data) => api.post(`/v1/tenants/${id}/admin`, data);
export const assignTenantAdmin = (id, userId) => api.post(`/v1/tenants/${id}/admins/assign`, { userId });
export const removeTenantAdmin = (id, userId) => api.delete(`/v1/tenants/${id}/admins/${userId}`);
export const getAdminCandidates = (params) => api.get('/v1/tenants/admin-candidates', { params });

export const getTenantModules = (id) => api.get(`/v1/tenants/${id}/modules`);
export const getAvailableModules = (id) => api.get(`/v1/tenants/${id}/available-modules`);
export const assignModule = (id, moduleId) => api.post(`/v1/tenants/${id}/modules/${moduleId}`);
export const removeModule = (id, moduleId) => api.delete(`/v1/tenants/${id}/modules/${moduleId}`);

export const updateModuleLicense = (tenantId, moduleId, data) =>
  api.put(`/v1/tenants/${tenantId}/modules/${moduleId}/license`, data);
